import { render, staticRenderFns } from "./ProgramCheck.vue?vue&type=template&id=3c3fbd6d&scoped=true"
import script from "./ProgramCheck.vue?vue&type=script&lang=js"
export * from "./ProgramCheck.vue?vue&type=script&lang=js"
import style0 from "./ProgramCheck.vue?vue&type=style&index=0&id=3c3fbd6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fbd6d",
  null
  
)

export default component.exports